import React from 'react'
import EditRoles from '../../../components/organisms/admin/roles/EditRoles'

type Props = {}

const EditRolesPage = (props: Props) => {
  return (
    <EditRoles />
  )
}

export default EditRolesPage